<template>
  <div class="about">
    <Banner
    :words="bannerTitle"
    :pictures="bannerPictures"/>

    <WhoWeAre
    :contentWords="contentWords"/>

    <GrayNumber
    :quaterContent="quaterContent"/>

    <!-- <License
    :license="license"/> -->

    <!-- <Fixedbg :pic="titleBackground">
      <h1 slot="title">This is a big title.</h1>
      <h2 slot="subtitle">This is a big title2.</h2>
      <h3 slot="content">welcome</h3>
      <template slot="btn">button</template>
    </Fixedbg> -->

    <!-- <Members
    :memberWords="memberWords"
    :memberCards="memberCards"/> -->

    <!-- <Fixedbg :pic="titleBackground2">
      <h1 slot="title">This is a big title.</h1>
      <h2 slot="subtitle">This is a big title2.</h2>
      <h3 slot="content">welcome</h3>
      <template slot="btn">button</template>
    </Fixedbg> -->

    <!-- <Award
    :awardsArea="awardsArea"/> -->

    <!-- <Performance
    :performance="performance"/> -->

    <Footer />

  </div>
</template>
<script>
// @ is an alias to /src
import Banner from '@/components/Banner_area.vue';
// import Fixedbg from '@/components/Area_fixedbg.vue';
import WhoWeAre from '@/components/About_WhoWeAre.vue';
// import License from '@/components/About_license.vue';
import GrayNumber from '@/components/grayNumber_area.vue';
// import Members from '@/components/Member_area.vue';
// import Award from '@/components/Award_area.vue';
// import Performance from '@/components/Performance_area.vue';
import Footer from '@/components/footer_information.vue';

export default {
  data() {
    return {
      bannerTitle: {
        title: '關於我們',
        smalltitle: 'ABOUT US',
        subtitle: '',
        content: '',
      },
      bannerPictures: [
        'https://picsum.photos/800/500?random=25',
        'https://picsum.photos/800/500?random=26',
        'https://picsum.photos/800/500?random=27',
        'https://picsum.photos/800/500?random=28',
        'https://picsum.photos/800/500?random=29',
      ],
      contentWords: {
        title: 'WHO WE ARE',
        topic: '三農科技有限公司',
        content: '天氣變化大，若能克服天氣障礙，農民將會更安心。我們將保護農田、成為農民的得力幫手，減少農損、提高作物產量、監測田野、取得田中數據，將科學轉換成農民也能了解的方式，以了解作物生長的變化，輕鬆守護整座農田。',
        button: '了解我們的服務',
      },
      quaterContent: [
        {
          number: '01.',
          topic: '監測',
          txt:
            '監測就是希望可以讓農民安心，減少農損、提高作物產量、監測田野、取得田中數據，將科學轉換成農民也能了解的方式，以了解作物生長的變化，輕鬆守護整座農田。',
        },
        {
          number: '02.',
          topic: '預測',
          txt:
            '氣候變遷大，尤其是突如其來的雨，都有可能會使得農民心血毀於一旦，因此透過預測，減少事發的可能，讓天氣變化之前就先預測，讓農民盡早做出相應的對策。',
        },
        // {
        //   number: '03.',
        //   topic: '監測',
        //   txt:
        //     '田間氣象監測，是給予農民安心的保證。',
        // },
        // {
        //   number: '04.',
        //   topic: '預測',
        //   txt:
        //     '田間氣象監測，是給予農民安心的保證。',
        // },
      ],
      license: {
        topic: '團體預報許可證',
        content: '氣象預報是特許行業，須得到預報證照才能提供預報資訊。天氣探長團隊由氣象博士與農學專家結合而成，致力投入將學理專業走入田間，帶領農業走向新契機。氣候變遷的可怕在於難以抓摸，但天氣探長的專長就在於帶您認識您的農田，利用天氣變化創造穩贏的營運計畫。',
        darkredname: '三農科技',
        picture: 'https://picsum.photos/500/500?random=5',
      },
      titleBackground: {
        url: 'https://picsum.photos/600/300?random=21',
        fixed: true,
      },
      memberWords: {
        title: 'TEAM MEMBERS',
        subtitle: '團隊成員',
        content: '天氣探長，與您一起探索作物健康成長！團隊致力於將農田監測裝置普及化、智能農業施作實際化，希望能在全球氣候環境劇烈變化的現今，及早窺探天機，以協助農友們在農務安排上捷足先登，便可力挽狂瀾，在危機處看見生機。',
        button: '獲取免費諮詢',
      },
      memberCards: [
        {
          name: '王小明',
          picture: 'https://picsum.photos/300/300?random=11',
          description: '三橫一束王、大小的小、明天的明',
        },
        {
          name: '王2明',
          picture: 'https://picsum.photos/300/300?random=12',
          description: '三橫一束王、大小的小、明天的明',
        },
        {
          name: '王3明',
          picture: 'https://picsum.photos/300/300?random=13',
          description: '三橫一束王、大小的小、明天的明',
        },
      ],
      titleBackground2: {
        url: 'https://picsum.photos/600/300?random=31',
        fixed: false,
      },
      awardsArea: {
        title: 'AWARD WINNING',
        subtitle: '獲獎經驗',
        awards: [
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
          {
            description: '2019 生醫產業與新農業 創新創業競賽',
            get: '新農業組 金獎',
          },
        ],
        pictures: [
          {
            description: '三橫一束王、大小的小、明天的明',
            picture: 'https://picsum.photos/600/400?random=11',
          },
          {
            description: '三橫一束王、大小的小、明天的明',
            picture: 'https://picsum.photos/600/400?random=12',
          },
          {
            description: '三橫一束王、大小的小、明天的明',
            picture: 'https://picsum.photos/600/400?random=13',
          },
        ],
      },
      performance: {
        title: '服務實績',
        // background: 'https://picsum.photos/600/300?random=30',
        cards: [
          {
            title: '屏東香蕉銷日破千噸',
            type: '',
            picture: 'https://i.epochtimes.com/assets/uploads/2020/07/319da2215b788c093895151dfc17a08e-600x400.jpg',
          },
          {
            title: '用AI種火龍果 搶外銷訂單',
            type: '',
            picture: 'https://s.yimg.com/ny/api/res/1.2/3qPi_Gl4q_tz5oqcTzz.Hg--/YXBwaWQ9aGlnaGxhbmRlcjt3PTk2MDtoPTU3ODtjZj13ZWJw/https://media.zenfs.com/ko/chinatimes_newspapers_146/84ef0920b4da6bb9300cbdd4ace09e62',
          },
          {
            title: '無人機於智慧農業應用研討會',
            type: '',
            picture: 'https://agritech-foresight.atri.org.tw/archive/news/20191113d612be96-2d1b-4f09-8290-5b887df0a4e5.jpg',
          },
        ],
      },
    };
  },
  components: {
    Banner,
    // Fixedbg,
    WhoWeAre,
    // License,
    GrayNumber,
    // Members,
    // Award,
    // Performance,
    Footer,
  },
};
</script>

<style lang="scss" scoped>

</style>
